<template>
  <div class="viper-radios" :style="{ width: width + 'px' }">
    <form-field-label :required="required">{{ schema.label }}</form-field-label>
    <div class="viper-radios-value">
      <form-field-value v-if="formOptions.readonly" :value="value"></form-field-value>
      <v-radio-group
        v-else
        v-model="model[schema.model]"
        class="mt-0"
        :disabled="formOptions.readonly"
        row
        @input="triggerValidation"
        @blur="triggerValidation"
      >
        <v-radio v-for="item in items" :key="item.id" :label="item.value" :value="item.id" />
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import FormFieldMixin from '@/components/form-fields/FormFieldMixin'
import FormFieldLabel from '@/components/form-fields/FormFieldLabel'
import FormFieldValue from '@/components/form-fields/FormFieldValue'
import _ from 'lodash'

export default {
  components: { FormFieldValue, FormFieldLabel },
  mixins: [FormFieldMixin],
  props: {
    items: { type: Array, required: true },
    options: { type: Array, required: true }
  },
  computed: {
    value() {
      let id = this.model[this.schema.model]
      let fieldOption = _.find(this.options, { id: id })
      return fieldOption ? fieldOption.value : null
    }
  }
}
</script>
